import firebaseJson from '@yp.nye/config/firebase.json' with { type: 'json' };
import { derivedLoadable, type Setter } from '@yp/util.svelte/loadable.ts';
import { PwaInstaller } from '@yp/web.app/client/pwa/install.ts';

export const IsInstallable = false;
export const CanInstall = derivedLoadable(
  PwaInstaller.instance().canInstall,
  ($can, set: Setter<boolean>) => set(IsInstallable && $can),
);

// export type IFirebaseConfig = {
//   projectId: string;
//   appId: string;
//   databaseURL: string;
//   storageBucket: string;
//   locationId: string;
//   apiKey: string;
//   authDomain: string;
//   messagingSenderId: string;
//   measurementId: string;
//   publicVapidKey: string;
// };

export const Config = {
  firebase: firebaseJson.firebase,
  cloudFunctionsUrl: `https://us-central1-${firebaseJson.firebase.projectId}.cloudfunctions.net`,
  // Only configuration for Cypress goes here
  // cypress: {
  //   baseUrl: 'http://localhost:8080',
  //   env: {
  //     firebase: defer(function firebaseSdk() {
  //       return this.firebase;
  //     }),
  //     TEST_UID: 'TestUser',
  //     TZ: 'America/Los_Angeles',
  //   },
  //   experimentalFetchPolyfill: true,
  //   retries: 3,
  // },
  environment: () => process.env.NODE_ENV ?? 'local',
  sentry: {
    dsn: 'https://0a486d1d6cb94b01b2aae7c5aea71f6e@o1060222.ingest.sentry.io/6049567',
    enabled: () => Boolean(window.process?.env?.LOCAL_DEV),
  },
};
